import React from "react";
import { FormBuilderProps, FormBuilder } from "@avamae/formbuilder";
import { useAdditionalData } from "helpers/useAdditionalData";
import { Spinner } from "components/Spinner/Spinner";

export default function FormElements<T>(
  props: FormBuilderProps<T> & { values: T }
) {
  const { data, values } = props;

  const { additionalData, pending } = useAdditionalData(data, values as any);

  return pending ? (
    <Spinner />
  ) : (
    <FormBuilder {...props} additionalData={additionalData} />
  );
}
